import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = { class: "mb-6" }
const _hoisted_3 = { class: "flex items-center justify-between bg-blue-50 border border-blue-200 text-blue-900 rounded-lg px-4 py-3" }
const _hoisted_4 = { class: "font-semibold" }
const _hoisted_5 = { class: "bg-white rounded-xl border border-gray-200 p-6 mb-6" }
const _hoisted_6 = {
  key: 0,
  class: "flex gap-6 mb-4"
}
const _hoisted_7 = { class: "flex items-center gap-3 cursor-pointer" }
const _hoisted_8 = { class: "flex items-center gap-3 cursor-pointer" }
const _hoisted_9 = { class: "relative mb-4" }
const _hoisted_10 = { class: "relative" }
const _hoisted_11 = ["onKeydown"]
const _hoisted_12 = {
  key: 0,
  class: "absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto"
}
const _hoisted_13 = {
  key: 0,
  class: "px-3 py-2 text-sm text-gray-500 flex items-center gap-2"
}
const _hoisted_14 = {
  key: 1,
  class: "px-3 py-2 text-sm text-red-600"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  class: "px-3 py-2 text-sm text-gray-500"
}
const _hoisted_17 = { class: "max-h-40 overflow-y-auto mb-4 border rounded-md" }
const _hoisted_18 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_19 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_20 = { class: "px-4 py-2 text-sm text-gray-900" }
const _hoisted_21 = { class: "px-4 py-2" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "flex justify-center mt-6" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = {
  key: 0,
  class: "fas fa-spinner fa-spin mr-2"
}
const _hoisted_27 = {
  key: 1,
  class: "fas fa-check mr-2"
}
const _hoisted_28 = { class: "p-4" }
const _hoisted_29 = { class: "text-sm text-gray-600 mb-4" }
const _hoisted_30 = { class: "bg-gray-50 rounded-lg p-3 max-h-40 overflow-y-auto mb-4" }
const _hoisted_31 = { class: "space-y-1" }
const _hoisted_32 = { class: "flex justify-end gap-3 mt-4" }

import { ref, reactive, computed, watch, onMounted, onUnmounted } from 'vue'
import { ModalComp } from '@/components'
import { useNotification } from '@/composables/useNotification'
import { 
  getMeaAutocomplete, 
  updateMeaProducts, 
  checkMonthlyMeaBeforeAdd,
} from '@/api/mea'


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductMeaRowModal',
  props: {
    visible: { type: Boolean },
    initialReferences: {}
  },
  emits: ["update:visible", "success"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const { success: showSuccessToast, error: showErrorToast } = useNotification()

// État local
const newReference = ref('')
const references = ref<string[]>([])
const isLoading = ref(false)
const monthlyLimit = ref(100)
const remainingJetons = ref(100)
const autocompleteResults = ref<Array<{ reference_base: string }>>([])
const showAutocomplete = ref(false)
const selectedIndex = ref(-1)
const autocompleteTimeout = ref<ReturnType<typeof setTimeout> | null>(null)
const showConfirmModal = ref(false)
const confirmModalMessage = ref('')
const isSearching = ref(false)
const lastAutocompleteError = ref<string | null>(null)

const formData = reactive({
  reassort: true,
  nouveaute: true
})

// Sync initial references when modal opens
watch(() => props.visible, (newVal) => {
  if (newVal) {
    if (props.initialReferences && props.initialReferences.length > 0) {
      // Filtrer les doublons et les valeurs vides
      const uniqueRefs = Array.from(new Set(props.initialReferences.filter(r => !!r)))
      references.value = [...uniqueRefs]
    } else {
      references.value = []
    }
    refreshRemainingJetons()
  }
}, { immediate: true })

const canSubmit = computed(() => {
  return (formData.reassort || formData.nouveaute) && references.value.length > 0
})

// Autocomplétion
const handleInput = async () => {
  if (autocompleteTimeout.value) clearTimeout(autocompleteTimeout.value)
  const term = newReference.value.trim()
  if (term.length < 2) {
    autocompleteResults.value = []
    showAutocomplete.value = false
    return
  }

  autocompleteTimeout.value = setTimeout(async () => {
    try {
      isSearching.value = true
      showAutocomplete.value = true
      const results = await getMeaAutocomplete(term, references.value.join('~'))
      autocompleteResults.value = results
      selectedIndex.value = -1
    } catch (error) {
      lastAutocompleteError.value = 'Erreur lors de la recherche'
    } finally {
      isSearching.value = false
    }
  }, 300)
}

const handleFocus = () => {
  if (newReference.value.trim().length >= 2) showAutocomplete.value = true
}

const handleBlur = () => {
  setTimeout(() => { showAutocomplete.value = false }, 200)
}

const closeAutocomplete = () => {
  showAutocomplete.value = false
  selectedIndex.value = -1
}

const selectNext = () => {
  if (selectedIndex.value < autocompleteResults.value.length - 1) selectedIndex.value++
}

const selectPrevious = () => {
  if (selectedIndex.value > 0) selectedIndex.value--
}

const selectReference = (reference: string) => {
  newReference.value = reference
  showAutocomplete.value = false
  selectedIndex.value = -1
  addReference()
}

const addReference = async () => {
  let ref = newReference.value.trim()
  if (selectedIndex.value >= 0 && autocompleteResults.value[selectedIndex.value]) {
    ref = autocompleteResults.value[selectedIndex.value].reference_base
  }
  if (!ref) return
  if (references.value.includes(ref)) {
    showErrorToast('Déjà dans la liste')
    return
  }

  // Validation rapide
  try {
    const results = await getMeaAutocomplete(ref, references.value.join('~'))
    if (results.some(r => r.reference_base === ref)) {
      references.value.push(ref)
      newReference.value = ''
      autocompleteResults.value = []
      showAutocomplete.value = false
    } else {
      showErrorToast('Référence introuvable')
    }
  } catch (e) {
    showErrorToast('Erreur de validation')
  }
}

const removeReference = (ref: string) => {
  references.value = references.value.filter(r => r !== ref)
}

const submitForm = async () => {
  if (!canSubmit.value) return
  isLoading.value = true
  try {
    const limitCheck = await checkMonthlyMeaBeforeAdd(references.value.length)
    if (!limitCheck.allowed) {
      showErrorToast(`Limite dépassée. Jetons restants: ${limitCheck.limit - limitCheck.currentCount}`)
      isLoading.value = false
      return
    }
    const typeText = formData.reassort && formData.nouveaute ? 'réassort et nouveautés' : (formData.reassort ? 'réassort' : 'nouveautés')
    confirmModalMessage.value = `Voulez-vous mettre en avant ${references.value.length} produit(s) en ${typeText} ?`
    showConfirmModal.value = true
  } catch (error) {
    showErrorToast('Erreur de vérification')
  } finally {
    isLoading.value = false
  }
}

const confirmSubmit = async () => {
  showConfirmModal.value = false
  isLoading.value = true
  try {
    const updated = await updateMeaProducts(references.value, {
      reassort: formData.reassort,
      nouveautes: formData.nouveaute,
    })
    if (updated > 0) {
      showSuccessToast(`${updated} produits mis en avant !`)
      await refreshRemainingJetons()
      emit('success')
      emit('update:visible', false)
    } else {
      showErrorToast('Ces produits ont déjà été mis en avant aujourd\'hui')
    }
  } catch (error) {
    showErrorToast('Erreur lors de la mise à jour')
  } finally {
    isLoading.value = false
  }
}

const refreshRemainingJetons = async () => {
  try {
    const check = await checkMonthlyMeaBeforeAdd(0)
    monthlyLimit.value = check.limit
    remainingJetons.value = Math.max(0, check.limit - check.currentCount)
  } catch (e) {
    remainingJetons.value = monthlyLimit.value
  }
}

onMounted(refreshRemainingJetons)
onUnmounted(() => { if (autocompleteTimeout.value) clearTimeout(autocompleteTimeout.value) })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(ModalComp), {
      isVisible: _ctx.visible,
      title: "Mise en avant des produits",
      size: "md",
      hideFooter: "",
      "onUpdate:isVisible": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:visible', $event)))
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "flex items-center gap-2" }, [
                _createElementVNode("i", { class: "fas fa-coins" }),
                _createElementVNode("span", { class: "text-sm" }, "Jetons restants ce mois-ci")
              ], -1)),
              _createElementVNode("div", _hoisted_4, _toDisplayString(remainingJetons.value) + " / " + _toDisplayString(monthlyLimit.value), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[14] || (_cache[14] = _createElementVNode("h3", { class: "text-lg font-medium text-gray-900 mb-4" }, "Gestion des MEA", -1)),
            false
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("label", _hoisted_7, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.reassort) = $event)),
                      class: "w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                    }, null, 512), [
                      [_vModelCheckbox, formData.reassort]
                    ]),
                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-sm font-medium text-gray-700" }, "Reassort", -1))
                  ]),
                  _createElementVNode("label", _hoisted_8, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.nouveaute) = $event)),
                      class: "w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                    }, null, 512), [
                      [_vModelCheckbox, formData.nouveaute]
                    ]),
                    _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-sm font-medium text-gray-700" }, "Nouveautés", -1))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _cache[10] || (_cache[10] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, " Ajouter une Référence base : ", -1)),
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newReference).value = $event)),
                  onInput: handleInput,
                  onKeydown: [
                    _withKeys(_withModifiers(addReference, ["prevent"]), ["enter"]),
                    _withKeys(_withModifiers(selectNext, ["prevent"]), ["down"]),
                    _withKeys(_withModifiers(selectPrevious, ["prevent"]), ["up"]),
                    _withKeys(closeAutocomplete, ["escape"])
                  ],
                  onBlur: handleBlur,
                  onFocus: handleFocus,
                  placeholder: "Référence base",
                  class: "w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                }, null, 40, _hoisted_11), [
                  [
                    _vModelText,
                    newReference.value,
                    void 0,
                    { trim: true }
                  ]
                ]),
                (showAutocomplete.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      (isSearching.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _cache[9] || (_cache[9] = [
                            _createElementVNode("i", { class: "fas fa-spinner fa-spin" }, null, -1),
                            _createTextVNode(" Recherche... ")
                          ])))
                        : (lastAutocompleteError.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(lastAutocompleteError.value), 1))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(autocompleteResults.value, (result, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: index,
                                  onClick: ($event: any) => (selectReference(result.reference_base)),
                                  class: _normalizeClass([
                      'px-3 py-2 cursor-pointer hover:bg-blue-50',
                      selectedIndex.value === index ? 'bg-blue-100' : ''
                    ])
                                }, _toDisplayString(result.reference_base), 11, _hoisted_15))
                              }), 128)),
                              (autocompleteResults.value.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Aucun résultat "))
                                : _createCommentVNode("", true)
                            ], 64))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _cache[15] || (_cache[15] = _createElementVNode("hr", { class: "my-4 border-gray-200" }, null, -1)),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("table", _hoisted_18, [
                _cache[13] || (_cache[13] = _createElementVNode("thead", { class: "bg-gray-50" }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { class: "px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase" }, "Référence"),
                    _createElementVNode("th", { class: "px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase" }, "Action")
                  ])
                ], -1)),
                _createElementVNode("tbody", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(references.value, (ref) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: ref,
                      class: "hover:bg-gray-50"
                    }, [
                      _createElementVNode("td", _hoisted_20, _toDisplayString(ref), 1),
                      _createElementVNode("td", _hoisted_21, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (removeReference(ref)),
                          class: "text-red-600 hover:text-red-900"
                        }, _cache[11] || (_cache[11] = [
                          _createElementVNode("i", { class: "fas fa-trash" }, null, -1)
                        ]), 8, _hoisted_22)
                      ])
                    ]))
                  }), 128)),
                  (references.value.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_23, _cache[12] || (_cache[12] = [
                        _createElementVNode("td", {
                          colspan: "2",
                          class: "px-4 py-4 text-center text-sm text-gray-500"
                        }, "Aucune référence", -1)
                      ])))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("button", {
                onClick: submitForm,
                disabled: !canSubmit.value || isLoading.value || references.value.length > remainingJetons.value || remainingJetons.value === 0,
                class: "w-full inline-flex justify-center items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 disabled:opacity-50 transition-colors"
              }, [
                (isLoading.value)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_26))
                  : (_openBlock(), _createElementBlock("i", _hoisted_27)),
                _createTextVNode(" Mettre en avant (" + _toDisplayString(references.value.length) + ") ", 1)
              ], 8, _hoisted_25)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["isVisible"]),
    _createVNode(_unref(ModalComp), {
      isVisible: showConfirmModal.value,
      title: "Confirmer la mise en avant",
      size: "sm",
      hideFooter: "",
      "onUpdate:isVisible": _cache[5] || (_cache[5] = ($event: any) => (showConfirmModal.value = $event))
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("p", _hoisted_29, _toDisplayString(confirmModalMessage.value), 1),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("ul", _hoisted_31, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(references.value, (ref) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: ref,
                  class: "text-xs text-gray-700"
                }, [
                  _cache[16] || (_cache[16] = _createElementVNode("i", { class: "fas fa-check text-green-500 mr-2" }, null, -1)),
                  _createTextVNode(_toDisplayString(ref), 1)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (showConfirmModal.value = false)),
              class: "px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
            }, " Annuler "),
            _createElementVNode("button", {
              onClick: confirmSubmit,
              class: "px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-md hover:bg-green-700"
            }, " Confirmer ")
          ])
        ])
      ]),
      _: 1
    }, 8, ["isVisible"])
  ], 64))
}
}

})